import React from "react";
import $ from "jquery";

window.jQuery = $;
window.$ = $;
global.jQuery = $;

const LoginPage = React.lazy(() => import("./pages/authentication/login/Login"));
const Register = React.lazy(() => import("./pages/authentication/Register"));
const ForgotPassword = React.lazy(() => import("./pages/authentication/ForgotPassword"));
const ResetPassword = React.lazy(() => import("./pages/authentication/ResetPassword"));
const SelfRegister = React.lazy(() => import("./pages/authentication/SelfOnboarding/SelfRegister"));

const route = [
    { path: ["/login", "/"], exact: true, name: "Login", component: LoginPage },
    { path: "/register", exact: true, name: "Register", component: Register },
    {
        path: "/forgot-password",
        exact: true,
        name: "Forgot Password",
        component: ForgotPassword
    },
    {
        path: "/reset-password",
        exact: true,
        name: "Reset Password",
        component: ResetPassword
    },
    {
        path: "/self-register",
        exact: true,
        name: "Self Register",
        component: SelfRegister
    }
];

export default route;
